<template>
  <v-card>
    <v-system-bar color="accent" dark window>
      <v-toolbar-title>{{editMode? 'Редактировать слово' : 'Добавить слово'}}</v-toolbar-title>
    </v-system-bar>
    
    <v-card-text>
      <v-flex xs12>
        <v-text-field v-model="word.word" label="Название" hide-details></v-text-field>
      </v-flex>
      <v-flex xs12 v-for="(block, index) in word.definitions" :key="index" class="grey lighten-3 my-2">
        <v-select :items="definitions" v-model="block.type" label="Тип блока" no-data-text="Типы отсутствуют"></v-select>
        <dantser-editor v-model="block.text" :init="config" :api-key="apiKey"></dantser-editor>
        
        <div class="text-xs-right">
          <v-btn icon @click="deleteBlock(index)"><v-icon>delete</v-icon></v-btn>
        </div>
      </v-flex>
      <v-flex xs12 class="text-xs-right">
        <a class="dashed" @click="addBlock">Добавить блок</a>
      </v-flex>
    </v-card-text>
    
    <v-card-actions class="pa-3">
      <v-btn color="success" dark @click="submitData" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close-dialog')" color="error">Отмена</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapState} from 'vuex'
  
  export default {
    name : 'GlossaryForm',
  
    props: {
      data: {
        type: Object,
        required: false,
        default: () => {return {
          word: "",
          definitions: []
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      },
      type: {
        type: String,
        required: false,
        default: 'system'
      }
    },
    
    computed:{
      ...mapState('helper', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
    },
    
    mounted(){
      this.word = Object.assign({}, this.data)
    },
    
    data() {
      return {
        word: { word: '', definitions: [] },
        definitions:[
          { value: 0, text: 'Дефиниция'},
          { value: 1, text: 'Этимология'},
          { value: 2, text: 'Идиома'},
          { value: 3, text: 'Прочее'}
        ],
        status:{
          btnDisabled: false,
          text: '',
          className:'green--text darken-1'
        }
      }
    },
    
    methods : {
      addBlock(){
        this.word.definitions.push({type: 0, text: ""})
      },
  
      deleteBlock(index){
        this.word.definitions.splice(index, 1)
      },
  
      submitData(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
        
        if(this.editMode){
          this.$store.dispatch('helper/updateWord', {type: this.type, word: this.word}).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
            this.$emit('save')
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
          })
        } else {
          this.$store.dispatch('helper/createWord', {type: this.type, word: this.word}).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
            this.$emit('save')
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
          })
        }
      }
    },
    
    watch:{
      data(){
        this.word = Object.assign({}, this.data)
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/help/components/Glossary/Forms/GlossaryForm.vue